<template>
	<div class="ov-field" :class="{ 'ov-field--invalid': invalid }">
		<label v-if="label" class="ov-field__label">{{ label }}</label>
		<input
			class="ov-input"
			:type="type"
			:value="modelValue"
			:placeholder="placeholder"
			:disabled="disabled"
			:readonly="readonly"
			@input="$emit('update:modelValue', $event.target.value)"
		/>
		<p v-if="invalid && errorMessage" class="ov-field__error">{{ errorMessage }}</p>
	</div>
</template>

<script>
export default {
	name: "OvInput",
	props: {
		modelValue: { type: [String, Number], default: "" },
		label: { type: String, default: "" },
		placeholder: { type: String, default: "" },
		type: { type: String, default: "text" },
		disabled: { type: Boolean, default: false },
		readonly: { type: Boolean, default: false },
		invalid: { type: Boolean, default: false },
		errorMessage: { type: String, default: "" },
	},
	emits: ["update:modelValue"],
};
</script>

<style lang="scss" scoped>
.ov-field {
	&__label {
		display: block;
		margin-bottom: var(--ds-space-1);
		font-size: var(--ds-font-size-xs);
		font-weight: var(--ds-font-weight-medium);
		color: var(--ds-color-text-muted);
	}

	&__error {
		margin: var(--ds-space-1) 0 0;
		font-size: var(--ds-font-size-xs);
		color: var(--ds-color-danger);
	}
}

.ov-input {
	display: block;
	width: 100%;
	height: var(--ds-control-height);
	padding: 0 var(--ds-space-3);
	font-family: inherit;
	font-size: var(--ds-font-size-sm);
	color: var(--ds-color-text);
	background: var(--ds-color-surface);
	border: var(--ds-border-width) solid var(--ds-color-border);
	border-radius: var(--ds-radius-sm);
	transition: border-color 0.15s, box-shadow 0.15s;

	&:hover:not(:disabled):not([readonly]) {
		border-color: #cbd5e1;
	}

	&:focus {
		outline: none;
		border-color: var(--ds-color-primary);
		box-shadow: var(--ds-focus-ring);
	}

	&:disabled,
	&[readonly] {
		background: var(--ds-color-bg);
		color: var(--ds-color-text-muted);
		cursor: not-allowed;
	}

	.ov-field--invalid & {
		border-color: var(--ds-color-danger);
	}
}
</style>
